import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, TextInput, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import SunIllustration from '../components/SunIllustration';

var INITIAL_POSTS = [
  {
    id: '1', user: 'BeautyInTheStruggle15', emoji: '✌️', date: 'Jan 28, 2025', tag: 'Opiates',
    text: '30 days sober today! This is a huge milestone for me. Every day feels like one step closer to who I was before...',
    hearts: 23, prays: 5, hasImage: true,
    comments: [{ u: 'NewDawn42', t: 'Incredible! So proud of you! 💪', time: '2h ago' }],
  },
  {
    id: '2', user: 'NewDawn42', emoji: '🌅', date: 'Jan 27, 2025', tag: 'Recovery',
    text: 'Just completed my first full week of all daily quests. Small wins matter. Grateful for this community.',
    hearts: 15, prays: 8, hasImage: false, comments: [],
  },
];

export default function ConnectScreen() {
  var tabState = useState('getting-started');
  var tab = tabState[0];
  var setTab = tabState[1];
  var postsState = useState(INITIAL_POSTS);
  var posts = postsState[0];
  var setPosts = postsState[1];
  var comState = useState(null);
  var commentingOn = comState[0];
  var setCommentingOn = comState[1];
  var txtState = useState('');
  var commentText = txtState[0];
  var setCommentText = txtState[1];

  function react(postId, type) {
    setPosts(posts.map(function(p) {
      if (p.id !== postId) return p;
      var update = {};
      update[type] = p[type] + 1;
      return Object.assign({}, p, update);
    }));
  }

  function addComment(postId) {
    if (!commentText.trim()) return;
    setPosts(posts.map(function(p) {
      if (p.id !== postId) return p;
      return Object.assign({}, p, {
        comments: p.comments.concat([{ u: 'Jackie C.', t: commentText, time: 'Just now' }]),
      });
    }));
    setCommentText('');
    setCommentingOn(null);
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.safe} edges={['top']}>
        <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
          <View style={styles.dateRow}>
            <Text style={styles.dateText}>Fri, Jan.24th</Text>
            <View style={styles.iconRow}>
              <Icon name="mail-outline" size={20} color={Colors.textMid} />
              <Icon name="notifications-outline" size={20} color={Colors.textMid} />
            </View>
          </View>
          <View style={styles.sunWrap}><SunIllustration size={55} /></View>

          {/* Tabs */}
          <View style={styles.tabRow}>
            {['getting-started', 'all'].map(function(t) {
              var isActive = tab === t;
              var label = t === 'getting-started' ? 'Getting started' : 'All milestones';
              return (
                <TouchableOpacity key={t} onPress={function() { setTab(t); }} style={[styles.tab, isActive && styles.tabActive]}>
                  <Text style={[styles.tabText, isActive && styles.tabTextActive]}>{label}</Text>
                </TouchableOpacity>
              );
            })}
          </View>

          {/* Badge */}
          <View style={styles.badgeWrap}>
            <View style={styles.badge}><Text style={styles.badgeText}>You and 21 others</Text></View>
            <Text style={styles.badgeSub}>recently reached this milestone!</Text>
          </View>

          {/* Posts */}
          {posts.map(function(post) {
            return (
              <View key={post.id} style={styles.postCard}>
                <View style={styles.postHeader}>
                  <View style={styles.avatar}><Text style={styles.avatarEmoji}>😊</Text></View>
                  <View>
                    <Text style={styles.postUser}>{post.user + ' ' + post.emoji}</Text>
                    <Text style={styles.postDate}>{post.date}</Text>
                  </View>
                </View>
                <View style={styles.tagRow}>
                  <View style={styles.tagPill}><Text style={styles.tagText}>{post.tag}</Text></View>
                </View>
                {post.hasImage && (
                  <View style={styles.postImage}><Text style={{ fontSize: 28, opacity: 0.5 }}>📸</Text></View>
                )}
                <Text style={styles.postBody}>{post.text}</Text>

                <View style={styles.reactionsRow}>
                  <TouchableOpacity onPress={function() { react(post.id, 'hearts'); }} style={styles.reactionBtn}>
                    <Icon name="heart" size={16} color={Colors.danger} />
                    <Text style={styles.reactionCount}>{post.hearts}</Text>
                  </TouchableOpacity>
                  <TouchableOpacity onPress={function() { react(post.id, 'prays'); }} style={styles.reactionBtn}>
                    <Text style={{ fontSize: 14 }}>🙏</Text>
                    <Text style={styles.reactionCount}>{post.prays}</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={function() { setCommentingOn(commentingOn === post.id ? null : post.id); }}
                    style={styles.commentLink}
                  >
                    <Text style={styles.commentLinkText}>
                      {post.comments.length > 0 ? post.comments.length + ' comments' : 'Add a comment'}
                    </Text>
                  </TouchableOpacity>
                </View>

                {commentingOn === post.id && (
                  <View style={styles.commentsSection}>
                    {post.comments.map(function(c, ci) {
                      return (
                        <View key={ci} style={styles.commentItem}>
                          <Text style={styles.commentUser}>{c.u} <Text style={styles.commentTime}>{c.time}</Text></Text>
                          <Text style={styles.commentBody}>{c.t}</Text>
                        </View>
                      );
                    })}
                    <View style={styles.commentInputRow}>
                      <TextInput
                        style={styles.commentInput}
                        value={commentText}
                        onChangeText={setCommentText}
                        placeholder="Write a comment..."
                        onSubmitEditing={function() { addComment(post.id); }}
                      />
                      <TouchableOpacity style={styles.commentPostBtn} onPress={function() { addComment(post.id); }}>
                        <Text style={styles.commentPostText}>Post</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                )}
              </View>
            );
          })}

          <View style={{ height: 20 }} />
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  scrollContent: { paddingBottom: 100 },
  dateRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 20, paddingTop: 8 },
  dateText: { fontSize: 13, color: Colors.textMid },
  iconRow: { flexDirection: 'row', gap: 8 },
  sunWrap: { alignItems: 'center', marginVertical: 4 },
  tabRow: { flexDirection: 'row', gap: 8, paddingHorizontal: 20, marginBottom: 12 },
  tab: { paddingVertical: 8, paddingHorizontal: 18, borderRadius: 20, backgroundColor: 'rgba(255,255,255,0.5)' },
  tabActive: { backgroundColor: Colors.primary },
  tabText: { fontSize: 13, fontWeight: '600', color: Colors.textMid },
  tabTextActive: { color: '#fff' },
  badgeWrap: { paddingHorizontal: 20, marginBottom: 14 },
  badge: { alignSelf: 'flex-start', backgroundColor: Colors.primary, paddingVertical: 6, paddingHorizontal: 16, borderRadius: 20 },
  badgeText: { color: '#fff', fontSize: 14, fontWeight: '600' },
  badgeSub: { fontSize: 13, color: Colors.textMid, marginTop: 4, marginLeft: 4 },
  postCard: { marginHorizontal: 20, marginBottom: 14, backgroundColor: Colors.card, borderRadius: 16, overflow: 'hidden' },
  postHeader: { flexDirection: 'row', alignItems: 'center', gap: 10, padding: 14, paddingBottom: 8 },
  avatar: { width: 36, height: 36, borderRadius: 18, backgroundColor: '#D0E0D5', alignItems: 'center', justifyContent: 'center' },
  avatarEmoji: { fontSize: 16 },
  postUser: { fontSize: 14, fontWeight: '700', color: Colors.textDark },
  postDate: { fontSize: 11, color: Colors.textLight },
  tagRow: { paddingHorizontal: 16, paddingBottom: 6 },
  tagPill: { alignSelf: 'flex-start', backgroundColor: 'rgba(58,124,165,0.12)', paddingVertical: 3, paddingHorizontal: 10, borderRadius: 10 },
  tagText: { fontSize: 11, color: Colors.primary, fontWeight: '600' },
  postImage: { marginHorizontal: 16, height: 130, borderRadius: 12, backgroundColor: '#B5C5B0', alignItems: 'center', justifyContent: 'center', marginBottom: 6 },
  postBody: { paddingHorizontal: 16, paddingBottom: 10, fontSize: 14, color: Colors.textDark, lineHeight: 21 },
  reactionsRow: { flexDirection: 'row', alignItems: 'center', gap: 14, paddingHorizontal: 16, paddingVertical: 10, borderTopWidth: 1, borderTopColor: Colors.border },
  reactionBtn: { flexDirection: 'row', alignItems: 'center', gap: 4 },
  reactionCount: { fontSize: 13, color: Colors.textMid },
  commentLink: { marginLeft: 'auto' },
  commentLinkText: { fontSize: 13, color: Colors.primary, fontWeight: '600' },
  commentsSection: { paddingHorizontal: 16, paddingBottom: 12, borderTopWidth: 1, borderTopColor: Colors.border, backgroundColor: 'rgba(0,0,0,0.02)' },
  commentItem: { marginTop: 8 },
  commentUser: { fontSize: 12, fontWeight: '700', color: Colors.textDark },
  commentTime: { fontWeight: '400', color: Colors.textLight, fontSize: 11 },
  commentBody: { fontSize: 13, color: Colors.textMid, marginTop: 2 },
  commentInputRow: { flexDirection: 'row', gap: 8, marginTop: 8 },
  commentInput: { flex: 1, paddingVertical: 8, paddingHorizontal: 12, borderRadius: 20, borderWidth: 1, borderColor: Colors.border, backgroundColor: '#fff', fontSize: 13 },
  commentPostBtn: { paddingVertical: 8, paddingHorizontal: 16, borderRadius: 20, backgroundColor: Colors.primary },
  commentPostText: { color: '#fff', fontSize: 12, fontWeight: '600' },
});
